export default __webpack_public_path__ + "static/media/Priest's Straps of the Limitless Cipher.7aa8145c.jpg";